import prettyBytes from "pretty-bytes";
import i18n from "i18next";

export const formatFileSize = (bytes) =>
  prettyBytes(bytes, { locale: i18n.language });
